import React, { useEffect } from 'react';
import './StagingBadge.scss';

const StagingBadge: React.FC = () => {
    // Check if we're in staging mode
    const isStaging = import.meta.env.VITE_IS_STAGING !== undefined;

    useEffect(() => {
        if (isStaging) {
            // Get build time from environment variables
            const buildTime = import.meta.env.VITE_BUILD_TIME;
            const buildTimestamp = import.meta.env.VITE_BUILD_TIMESTAMP;
            
            // Format build time for display
            const buildTimeFormatted = buildTime ? new Date(buildTime).toLocaleString() : 'Unknown';
            const buildAge = buildTimestamp ? Math.floor((Date.now() - parseInt(buildTimestamp)) / 1000 / 60) : 0;
            const buildAgeText = buildAge > 0 ? ` (${buildAge} min ago)` : '';
            
            // Beautiful console output for staging version
            const styles = {
                title: 'color: #ff9800; font-size: 16px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.3);',
                subtitle: 'color: #ffc107; font-size: 12px; font-weight: normal;',
                info: 'color: #4caf50; font-size: 11px;',
                warning: 'color: #ff5722; font-size: 11px; font-weight: bold;',
                border: 'color: #ff9800; font-size: 12px;',
                buildTime: 'color: #2196f3; font-size: 11px; font-weight: bold;'
            };

            console.log('%c╔══════════════════════════════════════════════════════════════╗', styles.border);
            console.log('%c║                    🚀 STAGING VERSION 🚀                    ║', styles.border);
            console.log('%c╠══════════════════════════════════════════════════════════════╣', styles.border);
            console.log('%c║  %c⚡ Environment: %cSTAGING                                 %c║', styles.border, styles.subtitle, styles.title, styles.border);
            console.log('%c║  %c🌐 Base URL: %chttps://cdn.eduonline.io/staging        %c║', styles.border, styles.subtitle, styles.info, styles.border);
            console.log('%c║  %c🏗️ Build Time: %c' + (buildTimeFormatted + buildAgeText).padEnd(31) + '%c║', styles.border, styles.subtitle, styles.buildTime, styles.border);
            console.log('%c║  %c🔧 Mode: %cDevelopment Testing                        %c║', styles.border, styles.subtitle, styles.info, styles.border);
            console.log('%c╠══════════════════════════════════════════════════════════════╣', styles.border);
            console.log('%c║  %c⚠️  WARNING: This is a staging environment!              %c║', styles.border, styles.warning, styles.border);
            console.log('%c║  %c   Do not use for production data or operations.        %c║', styles.border, styles.warning, styles.border);
            console.log('%c╚══════════════════════════════════════════════════════════════╝', styles.border);
            
            // Additional grouped console info
            console.groupCollapsed('🔍 Staging Environment Details');
            console.log('📊 Environment Variables:', {
                VITE_IS_STAGING: import.meta.env.VITE_IS_STAGING,
                NODE_ENV: import.meta.env.NODE_ENV,
                MODE: import.meta.env.MODE,
                DEV: import.meta.env.DEV,
                PROD: import.meta.env.PROD
            });
            console.log('🏗️ Build Information:', {
                'Build Time': buildTimeFormatted,
                'Build Timestamp': buildTimestamp,
                'Build Age (minutes)': buildAge,
                'Build Date ISO': buildTime
            });
            console.log('🌍 Current URL:', window.location.href);
            console.log('📱 User Agent:', navigator.userAgent);
            console.log('⚙️ Staging Features:', [
                'Debug mode enabled',
                'Enhanced logging',
                'Development tools available',
                'Test data environment',
                'Build time tracking'
            ]);
            console.groupEnd();
        }
    }, [isStaging]);

    if (!isStaging) {
        return null;
    }

    // Get build time for tooltip
    const buildTime = import.meta.env.VITE_BUILD_TIME;
    const buildTimestamp = import.meta.env.VITE_BUILD_TIMESTAMP;
    const buildTimeFormatted = buildTime ? new Date(buildTime).toLocaleString() : 'Unknown';
    const buildAge = buildTimestamp ? Math.floor((Date.now() - parseInt(buildTimestamp)) / 1000 / 60) : 0;
    const buildAgeText = buildAge > 0 ? ` (${buildAge} min ago)` : '';
    
    const tooltipText = `Staging Environment\nBuild: ${buildTimeFormatted}${buildAgeText}`;

    return (
        <div className="staging-badge staging-badge--bottom" title={tooltipText}>
            <span className="staging-badge__text">STAGING</span>
            <span className="staging-badge__build-time">{buildTimeFormatted.split(' ')[1] || ''}</span>
        </div>
    );
};

export default StagingBadge;
